import React from 'react'
import { Bar, HorizontalBar } from 'react-chartjs-2';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import { currencyCode } from '../utils/currency';

class SalesPlots extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: '1'
    };
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  computeSalesStats() {
    const { sales } = this.props

    const itemIndices = new Map([
      ['VWPACK', 0],
      ['VWLAY', 1],
      ['VWGO', 2],
      ['LOCKERCHARGER', 3]
    ])

    let amount = 0.00

    let amountsPerMethod = new Map([
      ['CASH', [0.00, 0.00, 0.00, 0.00]],
      ['TPV', [0.00, 0.00, 0.00, 0.00]],
      ['TOKEN', [0.00, 0.00, 0.00, 0.00]],
      ['RFID', [0.00, 0.00, 0.00, 0.00]]
    ])

    let qtyPerMethod = new Map([
      ['CASH', [0, 0, 0, 0]],
      ['TPV', [0, 0, 0, 0]],
      ['TOKEN', [0, 0, 0, 0]],
      ['RFID', [0, 0, 0, 0]]
    ])

    for (let sale of sales) {
      let amountsPerSaleMethod = amountsPerMethod.get(sale.PaymentMethod)
      let qtyPerSaleMethod = qtyPerMethod.get(sale.PaymentMethod)

      for (let item of sale.Items) {
        let itemAmount = (item.qty * item.price)

        if(item.qty > 1){
          amount += (itemAmount/item.qty)
          amountsPerSaleMethod[itemIndices.get(item.item)] += (itemAmount/item.qty)
        }else{
          amount += itemAmount
          amountsPerSaleMethod[itemIndices.get(item.item)] += itemAmount
        }

        qtyPerSaleMethod[itemIndices.get(item.item)] += item.qty
      }

      amountsPerMethod.set(sale.PaymentMethod, amountsPerSaleMethod)
      qtyPerMethod.set(sale.PaymentMethod, qtyPerSaleMethod)
    }

    return {
      amount: amount,
      amountsPerMethod: amountsPerMethod,
      qtyPerMethod: qtyPerMethod
    }
  }

  renderAmount() {
    const stats = this.computeSalesStats()

    const data = {
      labels: ['Pack', 'Lay', 'Go', 'Charger'],
      datasets: [
        {
          label: 'CASH',
          backgroundColor: '#10b981',
          data: stats.amountsPerMethod.get('CASH')
        },
        {
          label: 'TPV',
          backgroundColor: '#0b97ff',
          data: stats.amountsPerMethod.get('TPV')
        },
        {
          label: 'TOKEN',
          backgroundColor: '#f59e0b',
          data: stats.amountsPerMethod.get('TOKEN')
        },
        {
          label: 'RFID',
          backgroundColor: '#06b6d4',
          data: stats.amountsPerMethod.get('RFID')
        }
      ]
    }

    return (
      <Bar
        data={data}
        options={{
          scales: {
            xAxes: [{
              stacked: true,
              ticks: {
                autoSkip: false
              }
            }],
            yAxes: [{
              stacked: true,
              scaleLabel: {
                display: true,
                labelString: `TOTAL (${currencyCode()})`
              }
            }]
          },
          maintainAspectRatio: false,
          responsive: true,
          legend: {
            display: true,
          },
          tooltips: {
            mode: 'label',
            callbacks: {
              label: this.totalLabelEuros
            }
          }
        }}
      />
    )
  }

  sortAmountsPerCustomer() {
    const { sales } = this.props

    const amountsPerCustomer = new Map()

    for (let sale of sales) {
      let customerAmount = amountsPerCustomer.get(sale.Customer?._id)

      if (customerAmount === undefined) {
        customerAmount = [
          sale.Customer?.Fullname || 'Sin cliente',
          new Map([
            ['VWPACK', 0],
            ['VWLAY', 0],
            ['VWGO', 0],
            ['LOCKERCHARGER', 0]
          ])
        ]
      }

      for (let item of sale.Items) {
        let amount = customerAmount[1].get(item.item)
        customerAmount[1].set(item.item, amount + item.price)
      }

      amountsPerCustomer.set(sale.Customer?._id, customerAmount)
    }

    const reducer = (accumulator, currentValue) => accumulator + currentValue;

    let sortedAmountsPerCustomer = Array.from(amountsPerCustomer.values())
      .sort((a, b) => {
        return Array.from(b[1].values()).reduce(reducer) -
               Array.from(a[1].values()).reduce(reducer)
      })

    let names = sortedAmountsPerCustomer.map((value, index) => {
      return value[0]
    })

    let amounts = new Map([
      ['VWPACK',
        sortedAmountsPerCustomer.map((value, index) => {
            return value[1].get('VWPACK')
        })
      ],
      ['VWLAY',
        sortedAmountsPerCustomer.map((value, index) => {
            return value[1].get('VWLAY')
        })
      ],
      ['VWGO',
        sortedAmountsPerCustomer.map((value, index) => {
            return value[1].get('VWGO')
        })
      ],
      ['LOCKERCHARGER',
        sortedAmountsPerCustomer.map((value, index) => {
            return value[1].get('LOCKERCHARGER')
        })
      ]
    ])

    return {
      names: names,
      amounts: amounts
    }
  }

  renderAmountsPerCustomer() {
    const sortedAmountsPerCustomer = this.sortAmountsPerCustomer()

    const data = {
      labels: sortedAmountsPerCustomer.names,
      datasets: [
        {
          label: 'Pack',
          backgroundColor: '#0b97ff',
          data: sortedAmountsPerCustomer.amounts.get('VWPACK')
        },
        {
          label: 'Lay',
          backgroundColor: '#06b6d4',
          data: sortedAmountsPerCustomer.amounts.get('VWLAY')
        },
        {
          label: 'Go',
          backgroundColor: '#10b981',
          data: sortedAmountsPerCustomer.amounts.get('VWGO')
        },
        {
          label: 'Charger',
          backgroundColor: '#f59e0b',
          data: sortedAmountsPerCustomer.amounts.get('LOCKERCHARGER')
        }
      ],
    }

    return (
      <HorizontalBar
        data={data}
        options={{
          scales: {
            yAxes: [{
              stacked: true,
            }],
            xAxes: [{
              stacked: true,
              scaleLabel: {
                display: true,
                labelString: `TOTAL (${currencyCode()})`
              }
            }]
          },
          maintainAspectRatio: false,
          responsive: true,
          legend: {
            display: true,
          },
          tooltips: {
            callbacks: {
              label: this.totalLabelEuros
            }
          }
        }}
      />
    )
  }
  renderQty() {
    const stats = this.computeSalesStats()

    const data = {
      labels: ['Pack', 'Lay', 'Go', 'Charger'],
      datasets: [
        {
          label: 'CASH',
          backgroundColor: '#10b981',
          data: stats.qtyPerMethod.get('CASH')
        },
        {
          label: 'TPV',
          backgroundColor: '#0b97ff',
          data: stats.qtyPerMethod.get('TPV')
        },
        {
          label: 'TOKEN',
          backgroundColor: '#f59e0b',
          data: stats.qtyPerMethod.get('TOKEN')
        },
        {
          label: 'RFID',
          backgroundColor: '#06b6d4',
          data: stats.qtyPerMethod.get('RFID')
        }
      ]
    }

    return (
      <Bar
        data={data}
        options={{
          scales: {
            xAxes: [{
              stacked: true,
              ticks: {
                autoSkip: false
              }
            }],
            yAxes: [{
              stacked: true,
              scaleLabel: {
                display: true,
                labelString: 'TOTAL (Unidades)'
              }
            }]
          },
          maintainAspectRatio: false,
          responsive: true,
          legend: {
            display: true,
          },
          tooltips: {
            mode: 'label',
            callbacks: {
              label: this.totalLabel
            }
          }
        }}
      />
    )
  }

  sortQtyPerCustomer() {
    const { sales } = this.props

    const qtysPerCustomer = new Map()

    for (let sale of sales) {
      let customerQty = qtysPerCustomer.get(sale.Customer?._id)

      if (customerQty === undefined) {
        customerQty = [
          sale.Customer?.Fullname || 'Sin cliente',
          new Map([
            ['VWPACK', 0],
            ['VWLAY', 0],
            ['VWGO', 0],
            ['LOCKERCHARGER', 0]
          ])
        ]
      }

      for (let item of sale.Items) {
        if (item.price <= 0)
          continue

        let qty = customerQty[1].get(item.item)
        customerQty[1].set(item.item, qty + item.qty)
      }

      qtysPerCustomer.set(sale.Customer?._id, customerQty)
    }

    const reducer = (accumulator, currentValue) => accumulator + currentValue;

    let sortedQtysPerCustomer = Array.from(qtysPerCustomer.values())
      .sort((a, b) => {
        return Array.from(b[1].values()).reduce(reducer) -
               Array.from(a[1].values()).reduce(reducer)
      })

    let names = sortedQtysPerCustomer.map((value, index) => {
      return value[0]
    })

    let qties = new Map([
      ['VWPACK',
        sortedQtysPerCustomer.map((value, index) => {
            return value[1].get('VWPACK')
        })
      ],
      ['VWLAY',
        sortedQtysPerCustomer.map((value, index) => {
            return value[1].get('VWLAY')
        })
      ],
      ['VWGO',
        sortedQtysPerCustomer.map((value, index) => {
            return value[1].get('VWGO')
        })
      ],
      ['LOCKERCHARGER',
        sortedQtysPerCustomer.map((value, index) => {
            return value[1].get('LOCKERCHARGER')
        })
      ]
    ])

    return {
      names: names,
      qties: qties
    }
  }

  renderQtyPerCustomer() {
    const sortedQtyPerCustomer = this.sortQtyPerCustomer()

    const data = {
      labels: sortedQtyPerCustomer.names,
      datasets: [
        {
          label: 'Pack',
          backgroundColor: '#0b97ff',
          data: sortedQtyPerCustomer.qties.get('VWPACK')
        },
        {
          label: 'Lay',
          backgroundColor: '#06b6d4',
          data: sortedQtyPerCustomer.qties.get('VWLAY')
        },
        {
          label: 'Go',
          backgroundColor: '#10b981',
          data: sortedQtyPerCustomer.qties.get('VWGO')
        },
        {
          label: 'Charger',
          backgroundColor: '#f59e0b',
          data: sortedQtyPerCustomer.qties.get('LOCKERCHARGER')
        }
      ],
    }

    return (
      <HorizontalBar
        data={data}
        options={{
          scales: {
            yAxes: [{
              stacked: true,
            }],
            xAxes: [{
              stacked: true,
              scaleLabel: {
                display: true,
                labelString: 'TOTAL (Unidades)'
              }
            }]
          },
          maintainAspectRatio: false,
          responsive: true,
          legend: {
            display: true,
          },
          tooltips: {
            callbacks: {
              label: this.totalLabel
            }
          }
        }}
      />
    )
  }

  totalLabel(tooltipItem, data) {
      let label = data.datasets[tooltipItem.datasetIndex].label;
      let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

      let renderedLabel = label + ": " + value;
      if (tooltipItem.datasetIndex !== 0) {
          return renderedLabel
      } else {
          // Loop through all datasets to get the actual total of the index
          let total = 0;
          for (let i = 0; i < data.datasets.length; i++)
            total += data.datasets[i].data[tooltipItem.index];

          return ["Total: " + total, renderedLabel];
      }
  }

  totalLabelEuros(tooltipItem, data) {
    let label = data.datasets[tooltipItem.datasetIndex].label;
    let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

    let renderedLabel = label + ": " + value.toFixed(2);
    if (tooltipItem.datasetIndex !== 0) {
        return renderedLabel
    } else {
        // Loop through all datasets to get the actual total of the index
        let total = 0.00;
        for (let i = 0; i < data.datasets.length; i++)
          total += data.datasets[i].data[tooltipItem.index];

        return ["Total: " + total.toFixed(2), renderedLabel];
    }
}

  sortQtyPerLanguage() {
    const { sales } = this.props

    const qtysPerLanguage = new Map()

    for (let sale of sales) {
      let languageQty = qtysPerLanguage.get(sale.Language)

      if (languageQty === undefined) {
        languageQty = [
          sale.Language,
          new Map([
            ['VWPACK', 0],
            ['VWLAY', 0],
            ['VWGO', 0],
            ['LOCKERCHARGER', 0]
          ])
        ]
      }

      for (let item of sale.Items) {
        if (item.price <= 0)
          continue

        let qty = languageQty[1].get(item.item)
        languageQty[1].set(item.item, qty + item.qty)
      }

      qtysPerLanguage.set(sale.Language, languageQty)
    }

    const reducer = (accumulator, currentValue) => accumulator + currentValue;

    let sortedQtysPerLanguage = Array.from(qtysPerLanguage.values())
      .sort((a, b) => {
        return Array.from(b[1].values()).reduce(reducer) -
               Array.from(a[1].values()).reduce(reducer)
      })

    let names = sortedQtysPerLanguage.map((value, index) => {
      return value[0]
    })

    let qties = new Map([
      ['VWPACK',
        sortedQtysPerLanguage.map((value, index) => {
            return value[1].get('VWPACK')
        })
      ],
      ['VWLAY',
        sortedQtysPerLanguage.map((value, index) => {
            return value[1].get('VWLAY')
        })
      ],
      ['VWGO',
        sortedQtysPerLanguage.map((value, index) => {
            return value[1].get('VWGO')
        })
      ],
      ['LOCKERCHARGER',
        sortedQtysPerLanguage.map((value, index) => {
            return value[1].get('LOCKERCHARGER')
        })
      ]
    ])

    return {
      names: names,
      qties: qties
    }
  }

  renderQtyPerLanguage() {
    const sortedQtyPerLanguage = this.sortQtyPerLanguage()

    const data = {
      labels: sortedQtyPerLanguage.names,
      datasets: [
        {
          label: 'Pack',
          backgroundColor: '#0b97ff',
          data: sortedQtyPerLanguage.qties.get('VWPACK')
        },
        {
          label: 'Lay',
          backgroundColor: '#06b6d4',
          data: sortedQtyPerLanguage.qties.get('VWLAY')
        },
        {
          label: 'Go',
          backgroundColor: '#10b981',
          data: sortedQtyPerLanguage.qties.get('VWGO')
        },
        {
          label: 'Charger',
          backgroundColor: '#f59e0b',
          data: sortedQtyPerLanguage.qties.get('LOCKERCHARGER')
        }
      ],
    }

    return (
      <HorizontalBar
        data={data}
        options={{
          scales: {
            yAxes: [{
              stacked: true,
            }],
            xAxes: [{
              stacked: true,
              scaleLabel: {
                display: true,
                labelString: 'TOTAL (Unidades)'
              }
            }]
          },
          maintainAspectRatio: false,
          responsive: true,
          legend: {
            display: true,
          },
          tooltips: {
            callbacks: {
              label: this.totalLabel
            }
          }
        }}
      />
    )
  }

  render() {
   return (
      <div>
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === '1' })}
              onClick={() => { this.toggle('1'); }}
            >
              Importe
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === '2' })}
              onClick={() => { this.toggle('2'); }}
            >
              Importe por Cliente
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === '3' })}
              onClick={() => { this.toggle('3'); }}
            >
              Cantidad
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === '4' })}
              onClick={() => { this.toggle('4'); }}
            >
              Cantidad por Cliente
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === '5' })}
              onClick={() => { this.toggle('5'); }}
            >
              Cantidad por Idioma
            </NavLink>
          </NavItem>
        </Nav>

        <TabContent activeTab={this.state.activeTab}>
          <TabPane tabId="1">
            <div id="canvas-container">
              {this.renderAmount()}
            </div>
          </TabPane>
          <TabPane tabId="2">
            <div id="canvas-container">
              {this.renderAmountsPerCustomer()}
            </div>
          </TabPane>
          <TabPane tabId="3">
            <div id="canvas-container">
              {this.renderQty()}
            </div>
          </TabPane>
          <TabPane tabId="4">
            <div id="canvas-container">
              {this.renderQtyPerCustomer()}
            </div>
          </TabPane>
          <TabPane tabId="5">
            <div id="canvas-container">
              {this.renderQtyPerLanguage()}
            </div>
          </TabPane>
        </TabContent>
      </div>
    );
  }
}

export default SalesPlots

